// @ts-nocheck

import type {PaginatedResponses} from 'src/types/report';

import * as React from 'react';

import {withI18n} from 'src/utils/language-support';

import {Responses} from 'src/components/analytics/responses';
import Zero from 'src/components/lib/zero';
import SegmentedButton from 'src/components/lib/segmented-button';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';

import Phone from 'src/images/dashboard/phone.svg';

import css from './dashboard.css';


type DashboardResponsesProps = {
  recentResponseData: PaginatedResponses;
  flaggedResponseData: PaginatedResponses;
  flaggedWords: string[];
  multiEntityEnabled: boolean;
  isJourneyV2: boolean;
  handleViewSummaryClick: () => void;
  isViewSummaryVisible: boolean;
  t: (key: string, value: string) => string;
};

type TabOption = 'recent' | 'flagged';

class DashboardResponses extends React.Component<
  DashboardResponsesProps,
  {
    currentTab: TabOption;
  }
> {
  tabOptions: {
    label: string;
    value: TabOption;
  }[] = [
    {
      label: this.props.t('Flagged', 'Flagged'),
      value: 'flagged',
    },
    {
      label: this.props.t('Most_Recent', 'Most Recent'),
      value: 'recent',
    },
  ];

  state = {
    currentTab: this.tabOptions[0].value,
  };

  _handleChange(evt: any) {
    const {value} = evt.currentTarget;
    this.setState({
      currentTab: value,
    });
  }
  handleChange = this._handleChange.bind(this);

  render() {
    const {
      recentResponseData,
      flaggedResponseData,
      flaggedWords,
      multiEntityEnabled,
      isJourneyV2,
      handleViewSummaryClick,
      isViewSummaryVisible,
      t,
    } = this.props;
    const {currentTab} = this.state;
    const journeyPageRoute = isJourneyV2
      ? '/journeys/goal-selection'
      : '/journey/new';

    return (
      <div className={css.responseTabs}>
        <div className={css.subtitle}>
          {t('Recent_Responses', 'Recent Responses')}
        </div>
        <div className={css.segmentedAndViewSummaryBlock}>
          <SegmentedButton
            className={css.responseSelect}
            options={this.tabOptions}
            defaultValue="flagged"
            value={currentTab}
            onChange={this.handleChange}
          />
          {isViewSummaryVisible && (
            <Button
              iconRightName="chevron-right"
              onClick={handleViewSummaryClick}
              size="medium"
              type="tertiary"
            >
              {t('View_Summary', 'View Summary')}
            </Button>
          )}
        </div>
        {currentTab === 'flagged' && (
          <div className={css.responsesSection}>
            {flaggedResponseData.responses.length > 0 ? (
              <Responses
                responseData={flaggedResponseData}
                flagged={true}
                flaggedWords={flaggedWords}
                multiEntityEnabled={multiEntityEnabled}
              />
            ) : (
              <Zero
                className={css.zero}
                Icon={Phone}
                iconClassName={css.phone}
                title={`${t(
                  'No_Flagged_Responses_Yet',
                  'No Flagged Responses Yet',
                )}!`}
                text={`${t(
                  'This_is_where_you_will_see_your_flagged_survey_responses',
                  'This is where you will see your flagged survey responses',
                )}. ${t(
                  'Start_by_adding_touchpoints_and_activating_your_journey',
                  'Start by adding touchpoints and activating your journey.',
                )}`}
                linkText={t('Create_a_journey', 'Create a journey')}
                linkUrl={journeyPageRoute}
              />
            )}
          </div>
        )}
        {currentTab === 'recent' && (
          <div className={css.responsesSection}>
            {recentResponseData.responses.length > 0 ? (
              <Responses
                responseData={recentResponseData}
                multiEntityEnabled={multiEntityEnabled}
              />
            ) : (
              <Zero
                className={css.zero}
                Icon={Phone}
                iconClassName={css.phone}
                title={`${t(
                  'No_Recent_Responses_Yet',
                  'No Recent Responses Yet',
                )}!`}
                text={`${t(
                  'This_is_where_you_will_see_your_recent_survey_responses',
                  'This is where you will see your recent survey responses.',
                )} ${t(
                  'Start_by_adding_touchpoints_and_activating_your_journey',
                  'Start by adding touchpoints and activating your journey.',
                )}`}
                linkText={t('Create_a_journey', 'Create a journey')}
                linkUrl={journeyPageRoute}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withI18n(DashboardResponses);
